export default __webpack_public_path__ + "static/assets/f1f104c7edadddd36aac068d8e55ef19.svg";